export default __webpack_public_path__ + "static/media/Category=Sport.ad02b6b4.png";